import './App.css';

import React from 'react';
import logo from './logo.svg';

function App() {
  return (
    <div className="App">
      <header className="App-header">
    
        <p>
         We'll be back shortly
        </p>
        
      </header>
    </div>
  );
}

export default App;
